<template>
  <el-timeline>
    <el-timeline-item timestamp="第一步" placement="top">
      <el-card>
        <h4>下载模板</h4>
        <p><el-link type="primary" :href="downloadTemplateURL">{{ downloadTemplateName }}</el-link></p>
      </el-card>
    </el-timeline-item>
    <el-timeline-item timestamp="第二步" placement="top">
      <el-card>
        <h4>选择要导入的excel文件</h4>
        <!-- https://jsonplaceholder.typicode.com/posts/ :action="importExcelURL"-->
        <el-upload
          ref="upload"
          :action="importExcelURL"
          :file-list="fileList"
          :on-change="handleChange"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过60M</div>
        </el-upload>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</template>

<script>
import { exportExcelError } from '@/assets/js/common.js'
export default {
  props: {
    downloadTemplateURL: {
      type: String,
      default: ''
    },
    downloadTemplateName: {
      type: String,
      default: ''
    },
    importExcelURL: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isNew: { //新接口
      type: Boolean,
      default: false
    }
  },
  created() {
    console.log(this.downloadTemplateURL)
    // let data = {data: {errorList: [{errorInfo: '@无法被装换字', name: 'M11'}]}, code: 500}
    // this.handleAvatarSuccess(data)
  },

  data() {
    return {
      fileList: []
    }
  },
  methods: {
    submitUpload() {
      if (!this.fileList.length) return this.$message.error('请先选择文件')
      this.$refs.upload.submit()
    },
    handleChange(file) {
      let { raw: File } = file
      console.log(file)
      const isXLSX = Boolean(File.name.match(/xlsx/i))
      console.log(isXLSX)
      const isLt60M = File.size / 1024 / 1024 < 60
      if (!isXLSX) {
        this.$message.error('上传的文件只能是 XLSX 格式!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt60M) {
        this.$message.error('上传的文件大小不能超过 60MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.$refs.upload.clearFiles()
      this.$set(this.fileList, 0, file)
    },
    handleAvatarSuccess(res) {
      if (res.code != 'success' && res.code != '0') {
        let data = ''
        if (this.isNew) {
          data = res.data && res.data.errorList ? JSON.stringify(res.data.errorList) : ''
        } else {
          data = JSON.parse(res.result).data
        }
        console.log(res.data)
        console.log(data)
        if(!data) return this.$message.error(res.message)
        const h = this.$createElement
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, res.message)
          ]),
          showCancelButton: true,
          confirmButtonText: '下载错误信息',
          cancelButtonText: '取消'
        }).then(() => {
          this.$refs.upload.clearFiles()
          exportExcelError({ errorInfo: data }, '/Account/dataSearchVue/exportExcelErrorInfo.html')
        }).catch(() => {
          this.$refs.upload.clearFiles()
        });
        return false
      } else {
        let data = ''
        if (this.isNew) {
          data = res.data
        } else {
          data = JSON.parse(res.result).data
        }
        let msg = res.message
        if (!msg) msg = '导入成功'
        this.$alert(msg, '提示', {
          confirmButtonText: '确定'
        }).then(() => {
          this.$refs.upload.clearFiles()
          if (this.type == 'financialBrand' || this.type == 'priceManagement') {
            this.$emit('import-close', { type: 1, data })
          }
        })
      }

    },

    handleAvatarError(err) {
      this.$message.error('上传失败，请重新上传')
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
}
</style>